<template>
  <form ref="itemForm" class="list-item">
    <div class="list-item-line">
      <div class="list-item-line-group flex-column align-items-stretch">
        <base-input
          v-model="itemModel.name"
          :label="`${$t('REPAIRS.REPAIR_ITEM')} (*)`"
          :placeholder="$t('REPAIRS.REPAIR_ITEM')"
          :name="$t('REPAIRS.REPAIR_ITEM')"
          :disabled="!canEditItems"
        >
        </base-input>
        <validation-error :errors="apiValidationErrors.name" />
      </div>
      <div class="list-item-line-group flex-column align-items-stretch">
        <base-input
          v-model="itemModel.excerpt"
          :label="`${$t('REPAIRS.REPAIR_ITEM_DETAIL')}`"
          :placeholder="$t('REPAIRS.REPAIR_ITEM_DETAIL')"
          :disabled="!canEditItems"
        >
        </base-input>
        <validation-error :errors="apiValidationErrors.excerpt" />
      </div>
      <div class="list-item-line-group flex-column align-items-stretch">
        <base-input
          :label="`${$t('REPAIRS.REPAIR_ITEM_STATE')} (*)`"
          :placeholder="$t('REPAIRS.REPAIR_ITEM_STATE')"
          vid="component_condition"
          :disabled="!canEditItems"
        >
          <el-select
            v-model="itemModel.component_condition"
            :placeholder="
              itemModel.component_condition
                ? ''
                : $t('REPAIRS.REPAIR_ITEM_STATE')
            "
            :disabled="!canEditItems"
          >
            <el-option
              v-for="[key, condition] in Object.entries(
                conditionOptionsDisplay
              )"
              class="custom-select-option"
              :value="key"
              label=" "
              :key="key"
            >
              <div class="option-inner">
                <span class="icon" :class="condition?.color">
                  <i class="far" :class="condition?.iconName"></i>
                </span>
                <span class="text">{{ $t(`REPAIRS.${key}`) }}</span>
              </div>
            </el-option>
            <template v-if="itemModel.component_condition" #prefix>
              <div class="option-inner prefix">
                <span
                  class="icon"
                  :class="
                    conditionOptionsDisplay[itemModel.component_condition]
                      ?.color
                  "
                >
                  <i
                    class="far"
                    :class="
                      conditionOptionsDisplay[itemModel.component_condition]
                        ?.iconName
                    "
                  ></i>
                </span>
                <span class="text">
                  {{ $t(`REPAIRS.${itemModel.component_condition}`) }}
                </span>
              </div>
            </template>
          </el-select>
        </base-input>
        <validation-error :errors="apiValidationErrors.component_condition" />
      </div>
      <div class="list-item-line-group buttons align-self-end" v-if="itemId">
        <base-button
          class="add-image position-relative"
          icon
          size="sm"
          @click="showPictureModal = true"
          :disabled="!editable"
        >
          <i class="far fa-camera"></i>
          <span class="badge d-inline-block" v-if="itemModel.gallery.length" />
        </base-button>
        <!-- <base-button
          class="add-comment"
          icon
          size="sm"
          @click="commentSectionModalOpened = true"
          v-if="
            $currentUserCan($permissions.PERM_VIEW_ANY_COMMENTS) ||
            $currentUserCan($permissions.PERM_VIEW_COMMENTS)
          "
        >
          <i class="far fa-comment"></i>
          <span class="badge" v-if="itemModel.comments_count">
            {{ itemModel.comments_count }}
          </span>
        </base-button> -->
      </div>
    </div>

    <div class="list-item-line labor">
      <div
        class="part-labor"
        v-for="(component, index) in components"
        :key="index"
      >
        <div class="part-labor-item">
          <base-input
            v-model="component.component_name"
            :label="`${$t('REPAIRS.REPAIR_ITEM_PART')}`"
            :placeholder="$t('REPAIRS.REPAIR_ITEM_PART')"
            :name="$t('REPAIRS.REPAIR_ITEM_PART')"
            :disabled="!editable"
          />
          <validation-error :errors="apiValidationErrors.component_name" />
        </div>
        <div class="part-labor-item">
          <base-input
            v-model="component.component_code"
            :label="`${$t('REPAIRS.REPAIR_ITEM_PART_NUMBER')}`"
            :placeholder="$t('REPAIRS.REPAIR_ITEM_PART_NUMBER')"
            :disabled="!editable"
          />
          <validation-error :errors="apiValidationErrors.component_code" />
        </div>
        <div class="part-labor-item small">
          <base-input
            v-model.number="component.component_quantity"
            :label="`${$t('COMMON.QUANTITY')}`"
            :placeholder="$t('COMMON.QUANTITY')"
            :name="`${$t('COMMON.QUANTITY')}`"
            type="number"
            min="0"
            :disabled="!editable"
          />
          <validation-error :errors="apiValidationErrors.component_quantity" />
        </div>
      </div>

      <div class="part-labor">
        <div class="part-labor-item">
          <base-input
            v-model="itemModel.component_details"
            :label="`${$t('REPAIRS.REPAIR_ITEM_MANUAL_LABOR')} (*)`"
            :placeholder="$t('REPAIRS.REPAIR_ITEM_MANUAL_LABOR')"
            :disabled="!editable"
          />
          <validation-error :errors="apiValidationErrors.component_details" />
        </div>
        <div class="part-labor-item small clear-input-number-arrows">
          <base-input
            v-model.number="itemModel.repair_time_hour"
            :disabled="!editable"
            :label="`${$t('REPAIRS.REPAIR_ITEM_TIME')}`"
            :placeholder="$t('REPAIRS.REPAIR_ITEM_TIME')"
            append-icon="h"
            input-classes="border-right-0 p-2"
            input-group-classes="text-black border-2 purge-append-border input-group-text-p-2"
            min="0"
            step="0.01"
            type="number"
          >
            <template #append><span class="text-black">h</span></template>
          </base-input>
          <validation-error :errors="apiValidationErrors.repair_time_hour" />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-2">
      <div class="w-40 h-100">
        <base-button
          type="button"
          class="btn-outline-darker"
          @click="newItem"
          v-if="isLastItem"
        >
          <i class="fas fa-plus mr-1"></i> {{ $t("COMMON.ADD") }}
        </base-button>
        <base-button
          type="button"
          class="btn-danger"
          v-if="canRemoveItem"
          @click="removeItem"
        >
          <i class="fas fa-close mr-1"></i> {{ $t("COMMON.REMOVE") }}
        </base-button>
        <div class="d-inline-block" v-if="loading">
          <div class="custom-loading-icon"></div>
        </div>
      </div>

      <div class="list-item-line total w-auto p-2">
        <div class="d-flex align-items-start">
          <div class="radio-group" :class="{ 'mr-4': !itemModel.supplier }">
            <base-checkbox v-model="repairedExternally" :disabled="!editable">
              {{ $t("REPAIRS.REPAIRED_EXTERNALLY") }}
              {{
                itemModel.supplier
                  ? `(${itemModel.supplier?.company_name})`
                  : ""
              }}
            </base-checkbox>
            <a
              v-if="!!itemModel.supplier && editable"
              :title="$t('SUPPLIERS.CHANGE_SUPPLIER')"
              @click="addSupplierModalOpened = true"
              class="cursor-pointer mr-3 pl-2 text-black"
            >
              <i class="fas fa-sync" />
            </a>
          </div>
          <!-- <div class="d-flex ">
          </div> -->
          <div>
            <div class="radio-group">
              <base-checkbox v-model="repairedInternally" :disabled="!editable">
                {{ $t("REPAIRS.REPAIRED_INTERNALLY") }}
              </base-checkbox>
            </div>
            <div class="radio-group mt-2" v-if="itemModel.done">
              <base-checkbox
                v-model="itemModel.warranted"
                :disabled="!editable"
              >
                {{ $t("REPAIRS.REPAIRED_WARRANTY") }}
              </base-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="showReviewAlert"
      v-html="$t('REPAIRS.REVIEW_ALERT')"
      class="alert mt-3 text-black"
      role="alert"
      style="background-color: rgba(var(--primary-rgb), 0.2)"
    />

    <inspection-confirmation-modal
      :confirm-action="deleteItem"
      :confirm-button-text="$t('COMMON.YES_DELETE')"
      :loading="loading"
      :message="$t('REPAIRS.DELETE_THIS_ITEM_FROM_REPAIR')"
      :open.sync="showDeleteItemModal"
      modal-classes="modal-secondary cancel"
    />

    <modal
      :showClose="true"
      :show.sync="showPictureModal"
      modal-classes="picture"
    >
      <template #header>
        <h5 class="modal-title" id="inspection-picture">
          {{ $t("INSPECTIONS.ADD_PICTURES") }}
        </h5>
      </template>
      <div>
        <gallery-selector
          :label="$t('COMMON.PICTURES')"
          :defaultGallery="gallery"
          ressource_name="repair_items"
          :ressource_id="itemId"
          :field="itemModel.name"
          @galleryChanged="(gallery_urls) => (gallery = gallery_urls)"
        />
      </div>
      <template #footer v-if="editable">
        <base-button type="primary" class="btn save" @click="addImages">
          {{ $t("COMMON.SAVE") }}
        </base-button>
      </template>
    </modal>
    <comments-modal
      :open.sync="commentSectionModalOpened"
      :object="itemModel"
      @onCommentsChanged="get"
      :canAddComment="editable"
    />

    <modal
      :show.sync="addSupplierModalOpened"
      modal-classes="modal-secondary validate"
    >
      <template #header>
        <div class="header">
          <div class="header-left">
            <span> {{ $t("SUPPLIERS.SELECT_SUPPLIER") }} </span>
          </div>
          <div class="header-right">
            <button @click.prevent="addSupplierModalOpened = false">
              <i class="fal fa-times"></i>
            </button>
          </div>
        </div>
      </template>
      <div>
        <div v-if="addNewSupplier">
          <base-input
            v-model="supplier.company_name"
            :label="`${$t('SUPPLIERS.ADD_SUPPLIER')}`"
            :name="`${$t('COMMON.SUPPLIER')}`"
            :placeholder="$t('COMMON.SUPPLIER')"
          >
          </base-input>
          <validation-error :errors="apiValidationErrors.company_name" />
        </div>
        <div v-else>
          <base-input :label="`${$t('COMMON.SUPPLIER')}`">
            <supplier-selector
              v-if="$currentUserCan($permissions.PERM_VIEW_ANY_SUPPLIERS)"
              :filterOrganization="itemModel.organization?.id"
              :show-all="false"
              :supplier="itemModel.supplier?.id"
              :placeholder="`${$t('COMMON.SEARCH')}...`"
              @supplierChanged="(_, supplierData) => (supplier = supplierData)"
            />
          </base-input>
          <validation-error :errors="apiValidationErrors.supplier" />
        </div>
        <div class="radio-group mt-2">
          <base-checkbox
            v-model="addNewSupplier"
            :disabled="!editable || loading"
          >
            {{ $t("SUPPLIERS.ADD_SUPPLIER") }}
          </base-checkbox>
        </div>
      </div>
      <template #footer>
        <!-- <Button class="no" @click.prevent="addSupplierModalOpened = false">
          {{ $t("COMMON.NO") }}
        </Button> -->
        <Button
          :disabled="!editable || loading"
          v-if="addNewSupplier"
          @click.prevent="addSupplier"
          class="yes w-100"
        >
          <i class="fas fa-spinner fa-spin mr-1" v-if="loading"></i>
          {{ $t("COMMON.SUBMIT") }}
        </Button>
        <Button
          :disabled="!supplier.id || !editable || loading"
          v-else
          @click.prevent="setSupplier(supplier)"
          class="yes w-100"
        >
          {{ $t("COMMON.CHOOSE") }}
        </Button>
      </template>
    </modal>
  </form>
</template>
<script>
import { Button, Option, Select } from "element-ui";
import {
  repairItemConditionsOptionsDisplay,
  repairItemStatusesOption,
  REPAIR_ITEM_STATUS_APPROVED,
  REPAIR_ITEM_CONDITION_TO_REPLACE,
  REPAIR_ITEM_STATUS_DENIED,
  REPAIR_ITEM_STATUS_REVIEWED,
} from "@/constants/repairItems";
import formMixin from "@/mixins/form-mixin";
import BaseRadio from "@/components/Inputs/BaseRadio.vue";
import _ from "lodash";
import swal from "sweetalert2";
import ValidationError from "@/components/ValidationError.vue";
import InspectionConfirmationModal from "@/components/InspectionConfirmationModal.vue";
import GallerySelector from "@/components/GallerySelector.vue";
import CommentsModal from "@/components/Comments/CommentsModal.vue";
import { cloneDeep, isEqual, debounce } from "lodash";
import requestErrorMixin from "@/mixins/request-error-mixin";
import SupplierSelector from "@/components/SupplierSelector.vue";
import defaultSupplier from "../../../PurchasesModule/SupplierManagement/defaultSupplier";
import defaultRepairItem from "../defaultRepairItem";
import { mapGetters } from "vuex";

export default {
  name: "repair-item-form",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    BaseRadio,
    ValidationError,
    InspectionConfirmationModal,
    GallerySelector,
    CommentsModal,
    SupplierSelector,
  },

  mixins: [formMixin, requestErrorMixin],

  props: {
    item: {
      type: Object,
      required: true,
    },
    canEditStatus: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    canShowStatus: {
      type: Boolean,
      default: false,
    },
    canRemoveItem: {
      type: Boolean,
      default: false,
    },
    canEditComponents: {
      type: Boolean,
      default: false,
    },
    canEditTimes: {
      type: Boolean,
      default: false,
    },
    isLastItem: {
      type: Boolean,
      default: false,
    },
    withoutComponents: {
      type: Boolean,
      default: false,
    },
    withoutTimes: {
      type: Boolean,
      default: false,
    },
    canShowReviewAlert: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    let repair = { ...this.item.repair };
    let itemId = this.item?.id;
    let itemModel = { ...this.item };
    const backupData = { ...itemModel };
    const gallery = itemModel.gallery;
    const components = itemModel.components;
    const supplierData = cloneDeep({
      ...defaultSupplier,
      ...(itemModel.organization
        ? { organization: itemModel.organization }
        : {}),
    });
    const supplier = cloneDeep(supplierData);
    return {
      itemId,
      itemModel,
      backupData,
      repair,
      conditionOptionsDisplay: repairItemConditionsOptionsDisplay,
      statusOptions: repairItemStatusesOption,
      REPAIR_ITEM_CONDITION_TO_REPLACE,
      REPAIR_ITEM_STATUS_APPROVED,
      loading: false,
      formErrors: [],
      showDeleteItemModal: false,
      showPictureModal: false,
      commentSectionModalOpened: false,
      gallery,
      components,
      addSupplierModalOpened: false,
      addNewSupplier: false,
      supplierCompanyName: null,
      supplierData,
      supplier,
    };
  },

  computed: {
    ...mapGetters("profile", { me: "me" }),
    componentAmount: function () {
      if (this.withoutComponents) {
        return 0;
      }
      return (
        this.itemModel.component_quantity * this.itemModel.component_amount
      );
    },
    workAmount: function () {
      if (this.withoutTimes) {
        return 0;
      }
      return this.itemModel.repair_time_hour * this.itemModel.work_amount;
    },
    total: function () {
      return this.componentAmount + this.workAmount;
    },
    // readOnly: function () {
    //   return (
    //     !this.canEditComponents && !this.canEditTimes && !this.canEditStatus
    //   );
    // },
    canEditItems: function () {
      return !this.item.is_linked_to_inspection && this.editable;
    },
    sendDataFiltered: function () {
      const item = { ...this.itemModel };
      if (this.itemId) {
        for (const [key, value] of Object.entries(item)) {
          if (value == this.backupData[key]) {
            delete item[key];
          }
        }
      }

      return { ...item };
    },
    showReviewAlert: function () {
      return (
        this.canShowReviewAlert &&
        this.itemModel.status == REPAIR_ITEM_STATUS_REVIEWED
      );
    },
    repairedInternally: {
      get() {
        return this.itemModel.done && !this.itemModel.externally;
      },
      set(check) {
        if (check) {
          this.itemModel.done = true;
          this.itemModel.externally = false;
          this.itemModel.supplier = null;
        } else {
          this.itemModel.done = false;
        }
      },
    },
    repairedExternally: {
      get() {
        return this.itemModel.done && this.itemModel.externally;
      },
      set(check) {
        if (check) {
          this.itemModel.done = true;
          this.itemModel.externally = true;
        } else {
          this.itemModel.done = false;
        }
      },
    },
  },

  created: function () {},

  beforeDestroy: function () {},

  mounted: function () {},

  methods: {
    openCommentModal() {
      this.$emit("openCommentModal");
    },

    newItem() {
      this.$emit("addNewItem");
    },

    async saveItem() {
      if (!this.editable) {
        return;
      }

      this.formErrors = [];

      const sendDataFiltered = cloneDeep(this.sendDataFiltered);
      delete sendDataFiltered.type;
      delete sendDataFiltered.relationshipNames;
      delete sendDataFiltered.repair;
      delete sendDataFiltered.organization;
      delete sendDataFiltered.links;

      if (!Object.keys(sendDataFiltered).length) return;

      const item = {
        type: "repair-items",
        relationshipNames: defaultRepairItem.relationshipNames,
        repair: this.repair,
        organization: this.backupData.organization,
        ...this.sendDataFiltered,
      };

      if (this.itemId) {
        this.updateItem(item);
      } else {
        this.addItem(item);
      }
    },

    async addItem(item) {
      this.loading = true;
      try {
        const result = await this.$store.dispatch("repairItems/add", item);
        let resultFiltered = { ...result };
        this.itemId = result.id;

        for (const key of Object.keys(item)) {
          delete resultFiltered[key];
        }

        this.itemModel = {
          ...this.itemModel,
          ...resultFiltered,
          ...this.sendDataFiltered,
        };
        this.backupData = { ...result, ...item };
        this.addSupplierModalOpened = false;
        this.$emit("itemUpdated");
      } catch (error) {
        // this.$notify({
        //   type: "danger",
        //   message: "An error occurred while updating",
        // });
        this.formErrors = error.response?.data?.errors;
      } finally {
        this.loading = false;
      }
    },

    async updateItem(item) {
      this.loading = true;
      try {
        const result = await this.$store.dispatch("repairItems/update", {
          ...item,
          id: this.itemId,
        });
        let resultFiltered = { ...result };

        for (const key of Object.keys(item)) {
          if (!["externally", "supplier", "done", "warranted"].includes(key)) {
            delete resultFiltered[key];
          }
        }

        this.itemModel = {
          ...this.itemModel,
          ...resultFiltered,
          ...this.sendDataFiltered,
        };
        this.backupData = { ...result, ...item };
        this.addSupplierModalOpened = false;
        this.$emit("itemUpdated");
      } catch (error) {
        // this.$notify({
        //   type: "danger",
        //   message: "An error occurred while updating",
        // });
        this.formErrors = error.response.data.errors;
      } finally {
        this.loading = false;
      }
    },

    async get() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch(
          "repairItems/get",
          this.itemId
        );

        this.itemModel = { ...this.itemModel, ...result };
        this.backupData = { ...this.itemModel, ...result };
        this.$emit("itemUpdated");
      } catch (error) {
        // this.$notify({
        //   type: "danger",
        //   message: "An error occurred while updating",
        // });
        this.formErrors = error.response.data.errors;
      } finally {
        this.loading = false;
      }
    },

    removeItem() {
      if (this.itemId) {
        this.showDeleteItemModal = true;
      } else {
        this.$emit("deleteItem");

        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("REPAIRS.REPAIR_ITEM_DELETED"),
        });
      }
    },

    async deleteItem() {
      try {
        this.loading = true;
        swal.showLoading();

        await this.$store.dispatch("repairItems/destroy", this.itemId);

        this.$emit("deleteItem");

        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("REPAIRS.REPAIR_ITEM_DELETED"),
        });
        swal.close();
      } catch (error) {
        swal.close();
        await this.showRequestError(error, false);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.showDeleteItemModal = false;
        this.loading = false;
      }
    },
    addImages() {
      this.itemModel = { ...this.itemModel, gallery: this.gallery };
      this.$nextTick(function () {
        this.showPictureModal = false;
      });
    },

    saveItemDebounced: debounce(function () {
      this.saveItem();
    }, 500),

    setSupplier(supplier) {
      this.itemModel.supplier = supplier;
      this.itemModel.externally = true;
      this.supplier = this.supplierData;
    },

    async addSupplier() {
      this.loading = true;

      try {
        const supplierData = cloneDeep(this.supplier);
        delete supplierData.id;

        if (this.me.restrict_to_locations) {
          supplierData.allowedLocations = this.me.allowedLocations;
        }

        await this.$store.dispatch("suppliers/add", supplierData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("SUPPLIERS.SUPPLIER_ADDED"),
        });

        const supplier = await this.$store.getters["suppliers/supplier"];

        this.setSupplier(supplier);
      } catch (error) {
        this.formErrors = error.response.data.errors;
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    itemModel: {
      handler: function (newValue, oldValue) {
        if (this.readOnly) return;

        this.$emit("update:item", { ...newValue, id: this.itemId });

        if (
          [REPAIR_ITEM_STATUS_DENIED, REPAIR_ITEM_STATUS_REVIEWED].includes(
            newValue.status
          ) &&
          newValue.status != this.backupData.status
        ) {
          this.commentSectionModalOpened = true;
        }

        if (newValue.externally) {
          if (!this.itemModel.supplier) {
            this.addSupplierModalOpened = true;
          }
        } else {
          this.itemModel.supplier = null;
        }

        if (!newValue.done) {
          this.itemModel.supplier = null;
          this.itemModel.externally = false;
          this.itemModel.warranted = false;
        }

        if (newValue.done != this.backupData.done) {
          this.saveItem();
        } else {
          this.saveItemDebounced();
        }
      },
      deep: true,
    },

    addSupplierModalOpened: function (value) {
      if (!value) {
        this.itemModel.externally = this.backupData.externally;
      }
    },

    components: {
      handler: debounce(function (components) {
        this.itemModel.components = cloneDeep(components);
      }, 300),
      deep: true,
    },
    item: {
      handler: function () {
        const newObject = cloneDeep(this.item);
        const oldObject = cloneDeep(this.itemModel);

        delete oldObject.relationshipNames;
        delete oldObject.repair;
        delete oldObject.organization;
        delete oldObject.links;

        delete newObject.relationshipNames;
        delete newObject.repair;
        delete newObject.organization;
        delete newObject.links;

        if (isEqual(newObject, oldObject)) return;

        this.itemModel = { ...this.itemModel, ...newObject };
      },
      deep: true,
    },
    // item() {
    //   this.itemModel = cloneDeep(this.item);
    // },
    formErrors(errors) {
      this.setApiValidation(errors);
    },
    showPictureModal(value) {
      if (!value) {
        this.gallery = this.itemModel.gallery;
      }
    },
  },
};
</script>
<style lang="scss">
.w-60 {
  width: 60% !important;
}

.w-40 {
  width: 40% !important;
}

.clear-input-number-arrows {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield !important;
  }
}

.input-group-text-p-2 {
  .input-group-text {
    padding: 0.5rem !important;
  }
}

.text-black {
  color: #000 !important;
}

.estimate-details {
  .form-group {
    .input-group-text {
      // border-top-left-radius: 0;
      // border-bottom-left-radius: 0;
      // border-top-right-radius: 8px;
      // border-bottom-right-radius: 8px;
      border-radius: 0 8px 8px 0;
    }
  }
}
</style>
